import { Vue } from 'vue-property-decorator';
import loader from '../../../utils/loader';
import store from '../../../store';
import corporateService from '../../../services/corporate';
import tableMixin from '../../../Mixins/table';
import formMixin from '../../../Mixins/form';
import Form from '../../../form/form';
import { debounce } from 'lodash';
import { isContractEligibleForClinicUse } from '../../../utils/organization';

export default Vue.extend({
  store,
  mixins: [tableMixin, formMixin],
  data: () => ({
    loading: false,
    formCoupon: new Form({
      data() {
        return {
          id: '',
        };
      },
    }),
    search: '',
    statusOption: [
      {
        text: 'Active',
        value: 'active',
      },
      {
        text: 'Inactive',
        value: 'inactive',
      },
    ],
    selectedStatus: [],
    corporates: [],
    totalPages: 0,
    totalcorporates: 0,
    corporatePagination: {},
    isCreateOrganizationModal: false,
    corporateHeaders: [
      { text: 'ID', align: 'center', value: 'id', sortable: true },
      { text: 'Organization', align: 'center', value: 'name', sortable: false },
      { text: 'Package Type', align: 'center', value: 'package_type', sortable: false },
      { text: 'Package Expiry', align: 'center', value: 'expire', sortable: true },
      { text: 'Active', align: 'center', value: 'active', sortable: false },
      { text: 'Action', align: 'center', value: 'id', sortable: false },
    ],
  }),
  computed: {
    ceil() {
      return Math.ceil;
    },
  },
  watch: {
    corporatePagination: {
      handler() {
        this.getCorporateList().then((data) => {
          this.corporates = data.items;
          this.totalcorporates = data.total;
          this.totalPages = data.totalPages;
        });
      },
      deep: true,
    },
    search() {
      this.getCorporateList().then((data) => {
        this.corporates = data.items;
        this.totalcorporates = data.total;
        this.totalPages = data.totalPages;
      });
    },
    selectedStatus() {
      this.getCorporateList().then((data) => {
        this.corporates = data.items;
        this.totalcorporates = data.total;
        this.totalPages = data.totalPages;
      });
    },
  },
  created() {},
  methods: {
    packageTypeLabel(value) {
      const map = {
        time: 'Bundle',
        free: 'PPU',
        donation: 'WoS',
      };
      return map[value] || value || '-';
    },
    getCorporateList() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const {
          sortBy,
          // descending,
          sortDesc,
          page,
          itemsPerPage,
        } = this.corporatePagination;

        let query = {};
        if (itemsPerPage !== -1) {
          query.per_page = itemsPerPage;
          query.page = page;
        }
        if (sortBy.length) {
          query.order = sortBy[0];
          query.sort = sortDesc[0] ? 'desc' : 'asc';
        } else {
          // Default: orgs expiring soonest at the top, regardless of active status.
          // The "soonest" framing means we want future-dated expiries first, not
          // every already-expired org from 2018 onwards. The OrganizationRepository
          // sort can't filter by "future-only" without also adding a where clause,
          // so we don't try — we just sort asc by expire and accept that the very
          // top rows on page 1 may be already-expired.
          //
          // The "expiring soon" badge below uses the active-and-future criterion
          // explicitly, so the badge stays correct even when the table itself
          // includes past-expired rows.
          query.order = 'expire';
          query.sort = 'asc';
        }
        if (this.selectedStatus.length == 1) {
          query.active = this.selectedStatus[0] == 'active' ? true : false;
        }
        if (this.search) query.q = this.search;

        corporateService
          .all(query)
          .then((data) => {
            this.loading = false;
            // Backend now guarantees active orgs sort before inactive ones
            // when order=expire (see OrganizationRepository active DESC, expire ASC).
            // So on page 1, the first rows are always the active orgs expiring
            // soonest. We mark the first 5 active rows on page 1 with the badge.
            // On any other page, no badges fire — those orgs are not urgent.
            const isDefaultSort = !sortBy.length;
            const isPageOne = (page || 1) === 1;
            let activeCount = 0;

            let items = data.data.map((e) => {
              let isExpiringSoon = false;
              if (isDefaultSort && isPageOne && e.active) {
                activeCount += 1;
                isExpiringSoon = activeCount <= 5;
              }
              return {
                ...e,
                isClinicEligible: e.contracts.length > 0 && isContractEligibleForClinicUse(e.contracts[0]),
                isExpiringSoon,
              };
            });
            let returnData = {
              items,
              total: 0,
            };

            const { meta } = data;

            if (meta) {
              const { total, last_page } = meta;
              returnData.total = total;
              returnData.totalPages = last_page;
            }

            resolve(returnData);
          })
          .catch((err) => {
            this.loading = false;
            reject(err);
          });
      });
    },
    doneCreation(isDone) {
      this.isCreateOrganizationModal = false;
      if (isDone) {
        this.refresh();
      }
    },
    refresh() {
      this.getCorporateList().then((data) => {
        this.corporates = data.items;
        this.totalcorporates = data.total;
        this.totalPages = data.totalPages;
      });
    },
    viewCorporate(id) {
      window.router.push({
        name: 'corporateProfile',
        params: {
          id: id,
        },
      });
    },
    debounceInput: debounce(function (e) {
      this.search = e;
    }, 500),
  },
  components: {
    CreateCorporate: loader.component('CreateCorporate'),
  },
});
